
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/expo",
      function () {
        return require("private-next-pages/expo.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/expo"])
      });
    }
  